
import BaseMixin from '@/views/mixin.vue'
import compSearch from './search'
import { mapState, mapGetters } from 'vuex'
import {
    HttpGetChannelSFPList,
    HttpBatchSFPDelete,
} from '@/service/products/channel'
import { Dropdown, Icon, Button } from 'view-design'

import compIndex from './update'

export default {
    mixins: [BaseMixin],
    components: {
        compSearch,
        compIndex,
        compUpload: () => import("@components/templates/upload"),
    },
    data () {
        return {
            isSuper: this.$store.state.userinfo.isSuper,
            fudingdan: 0,
            channelInfo: false,
        };
    },
    created () {
        this.channelInfo = this.handleAuth('erp.productChannel.delete');
    },
    methods: {
        httpList: HttpGetChannelSFPList,
        handleOperate (data, type, row) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeids: data,
                        querytype: 'query'
                    }
                    break;
                case 'queryBlank':
                    const url = this.$router.resolve({
                        name: 'proSfpUpdate',
                        params: { type: 'query' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'add': {
                    this.$router.push({
                        name: 'proSfpAdd',
                        params: { type: 'add' },
                    });
                    break;
                }
                case 'delete':
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        this.showDel = true;
                        this.operate = {
                            title: '移除',
                            desc: `确认移除产品SFP属性？`,
                            type,
                            id: data,
                        }
                    }
                    break;
                case 'import':
                    this.operate = {
                        show: true,
                        title: "导入数据",
                        showDesc: false,
                        data: { contextId: global.SYSID, property: 'SFP' },
                        component: "compUpload",
                        name: "excelFile",
                        showFooter: false,
                        action: process.env.VUE_APP_APIURL_BOSS + "/api/v1/ProductChannel/importProperty",
                        download: () => {
                            this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v1/ProductChannel/downPropertyModel', {}, 'download')
                        },
                        on: {
                            'on-success': (res) => {
                                this.$VModal.destroy();
                            },
                        }
                    };
                    break;
            }
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'delete': request = HttpBatchSFPDelete; params = { ids: this.checkedId.join(',') || id }; break;
            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
    },
    computed: {
        ...mapState('boss', ['warehouseList']),
        ...mapGetters('diction', ['getNewDifferentAllProductList']),
        columns () {
            let datalist = [{
                type: 'selection',
                width: 60,
            }, {
                title: "操作",
                width: 95,
                render: (h, { row }) => {
                    const id = row.id, status = row.orderStatus;
                    return <Button class='splitline' v-show={this.channelInfo == true} nativeOnClick={this.handleOperate.bind(this, id, 'delete')}>移除</Button>
                }
            },
            {
                title: '店铺/Seller SKU',
                // width:80,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.accountFlag}</div>
                        <div>
                            <a onClick={this.handleOperate.bind(this, row.id, 'query')}>{row.sellerSku}</a>
                            <a onClick={this.handleOperate.bind(this, row.id, 'queryBlank')}><Icon class="margin-left-10 font-14" type="ios-browsers-outline" /></a>
                        </div>

                    </div>
                },

            },
            {
                title: '项目/ERPSKU',
                // width:100,
                render: (h, { row }) => {
                    return <div>
                        <div><span class="font-bold">{this.findRenderLabel(this.getNewDifferentAllProductList, row.lineId)}</span></div>
                        <div>{row.erpSku}</div>
                    </div>

                },
            },
            {
                title: '是否停用',
                width: 100,
                render: (h, { row }) => {
                    return <div>{row.status == 'Y' ? '否' : '是'}</div>
                },

            },
            {
                title: '上下架状态/发货方式',
                // width:100,
                render: (h, { row }) => {
                    let saleState;
                    switch (row.saleState) {
                        case 'Hit Shelve': saleState = '上架'; break;
                        case 'Not Sell': saleState = '下架'; break;
                        case 'Off Shelve': saleState = '临时下架'; break;
                    }
                    return <div>
                        <div>{saleState}</div>
                        <div>{row.skuOrderType == 0 ? '自动' : '手动'}</div>
                    </div>
                },

            },
            {
                title: 'Asin/Item Label',
                // width:200,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.asin || '-'}</div>
                        <div>{row.fnSku || '-'}</div>
                    </div>
                },

            },
            {
                title: 'list/Your/Sale Price',
                width: 150,
                render: (h, { row }) => {

                    return <div>
                        <div>{row.price} {row.currencyCode}</div>
                        <div>{row.yourPrice} {row.currencyCode}</div>
                        <div>{row.salePrice} {row.currencyCode}</div>
                    </div>
                }
            },
            {
                title: 'AMZ上架/更新时间',
                // width:100,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.amazonTime || '-'}</div>
                        <div>{row.updatedAt || '-'}</div>
                    </div>

                },
            },

            ];
            return datalist;
        },
    },
};




